import styled          from 'styled-components';

import { themeColors } from 'src/providers/theme/shared';



type HorizontalDividerLookAndFeel = {
  lineColor: string;
  lineHeight: number;
}

const horizontaldivider_gray4_1px: HorizontalDividerLookAndFeel = {
  lineColor: themeColors.SecondaryGray4,
  lineHeight: 1,
}

const horizontaldivider_transparent_4px: HorizontalDividerLookAndFeel = {
  lineColor: themeColors.Transparent,
  lineHeight: 4,
}

const horizontaldivider_transparent_10px: HorizontalDividerLookAndFeel = {
  lineColor: themeColors.Transparent,
  lineHeight: 10,
}

export type HorizontalDividerVariants = 'gray4_1px' | 'transparent_4px' | 'transparent_10px';

export const horizontaldivider_variants: Map<HorizontalDividerVariants, HorizontalDividerLookAndFeel> = 
  new Map<HorizontalDividerVariants, HorizontalDividerLookAndFeel>([
    ['gray4_1px', horizontaldivider_gray4_1px],
    ['transparent_4px', horizontaldivider_transparent_4px],
    ['transparent_10px', horizontaldivider_transparent_10px],
  ]);

export const Container = styled.div<{
  lookAndFeel: HorizontalDividerLookAndFeel
}>`
  width: 100%;
  height: ${(args) => args.lookAndFeel.lineHeight}px;
  background-color: ${(args) => args.lookAndFeel.lineColor};
`
